import { render, staticRenderFns } from "./room_info.vue?vue&type=template&id=d4cfd440&"
import script from "./room_info.vue?vue&type=script&lang=js&"
export * from "./room_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports